import { ScheduleActionType, ScheduleActionTypes, ScheduleState, State } from "./scheduleTypes";



const INIT_STATE: ScheduleState = {
    loading : false,
    schedules : [],
    modal : false,
    error : ''
};




const scheduleReducer = (state: State = INIT_STATE, action: ScheduleActionType): any => {
   
    switch (action.type) {
        case ScheduleActionTypes.API_RESPONSE_SUCCESS:
            if (!action.payload) return { ...state }; 
            switch (action.payload.actionType) {
              
                case ScheduleActionTypes.UPDATE_SCHEDULE: {
                    return {
                        ...state,
                        schedule: action.payload.data,
                        modal: false,
                        loading: false,
                        error:''
                    };
                }
                case ScheduleActionTypes.GET_SCHEDULES: {
                    
                    return {
                        ...state,
                        schedules: action.payload.data,
                        loading: false,
                    };
                }
                case ScheduleActionTypes.OPEN_MODAL:{
                    return {
                        ...state,
                        loading: false,
                        modal: true,
                        error:''
                    };
                }
                case ScheduleActionTypes.CLOSE_MODAL:{
                    return {
                        ...state,
                        loading: false,
                        modal:false,
                    };
                }
                default:
                    return { ...state };
            }

        case ScheduleActionTypes.API_RESPONSE_ERROR:
            if (!action.payload) return { ...state };
            switch (action.payload.actionType) {
             
                case ScheduleActionTypes.UPDATE_SCHEDULE: {
                    return {
                        ...state,
                        error:action.payload.error,
                        loading: false,
                    };
                }
                case ScheduleActionTypes.GET_SCHEDULES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
              
                default:
                    return { ...state };
            }
          
        default:
            return { ...state };
    }
};

export default scheduleReducer;
